export default "__VITE_ASSET__7f102101__"